document.addEventListener('DOMContentLoaded', function () {
  // Galerie produit : clic sur une miniature = image principale
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        if (main && src) {
          main.src = src;
          if (srcset) main.srcset = srcset;
          main.alt = thumb.getAttribute('data-alt') || '';
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  });

  // Prix de la variante sélectionnée
  document.querySelectorAll('[data-variant-price]').forEach(function (form) {
    var out = form.querySelector('[data-price-out]');
    form.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (out && input.dataset.price) out.textContent = input.dataset.price;
      });
    });
  });

  // Tri des collections
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Quantité +/-
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value || '0', 10) + parseInt(btn.dataset.step, 10);
        var min = parseInt(input.min || '0', 10);
        input.value = Math.max(min, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Ferme le menu mobile quand on clique un lien
  document.querySelectorAll('.nav-mobile a').forEach(function (a) {
    a.addEventListener('click', function () {
      var d = a.closest('details.nav-mobile');
      if (d) d.removeAttribute('open');
    });
  });
});
